import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import { serve,emails,http,server,server2 } from '@/api/uesr'
// import { serve,http } from '@/api/uesr'
import VueI18n from 'vue-i18n'
import cn  from './lang/chinese'    // 引入lang文件
import  en from './lang/english'
import md5 from 'md5'
import ar  from './lang/ar'    // 引入lang文件
import  de from './lang/de'

import es  from './lang/es'    // 引入lang文件
import  fr from './lang/fr'

import hi  from './lang/hi'    // 引入lang文件
import  ko from './lang/ko'

import pt  from './lang/pt'    // 引入lang文件
import  ru from './lang/ru'

import  tw from './lang/tw'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.use(VueI18n)  

const i18n = new VueI18n({
  locale: 'cn',   // 设置语言
  messages: {
    cn:{
      ...cn,
    } ,
    tw:{
      ...tw,
    } ,
    en:  {
      ...en ,
    },

    ar:{
      ...ar,
    } ,
    de:  {
      ...de ,
    },
    es:{
      ...es,
    } ,
    fr:  {
      ...fr ,
    },
    hi:{
      ...hi,
    } ,
    ko:  {
      ...ko ,
    },
    pt:{
      ...pt,
    } ,
    ru:  {
      ...ru ,
    }
  },
  silentTranslationWarn: false, // 是否关闭翻译报错;
})
initLocalLang()
function initLocalLang () {
  // element-ui组件国际化
  Vue.use(Vant, {
    i18n: (key, value) => i18n.t(key, value)
  })
}

// Vue.prototype.$serve = serve
// Vue.prototype.$http = http

Vue.prototype.$md5 = md5
Vue.prototype.$serve = serve
Vue.prototype.$server = server
Vue.prototype.$server2 = server2
Vue.prototype.$http = http
Vue.prototype.$email = emails

Vue.config.productionTip = false
Vue.use(Vant);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
